import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { changeCustomSpeciality } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import { changeSpeciality } from "../actions/index";
import FormSpeciality from "./form/formSpeciality.component";

const Speciality: React.FC = () => {
  const dispatch = useDispatch();

  const specialities = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.specialities
  );

  const { customSpeciality, speciality } = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo
  );

  const selectSpeciality = speciality;

  const onInputChange = (event: any) => {
    const { value } = event.target;
    const selectedSpeciality = specialities.filter(
      (speciality) => speciality.id === parseInt(value)
    )[0];
    dispatch(changeSpeciality(selectedSpeciality));
  };

  const onInputChangeCustomSpeciality = (event: any) => {
    const { value } = event.target;
    dispatch(changeCustomSpeciality(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"12"} title={"What is your speciality?"} />
        <FormSpeciality
          specialityAreas={specialities}
          onInputChange={onInputChange}
          onInputChangeCustomSpeciality={onInputChangeCustomSpeciality}
          selectSpeciality={selectSpeciality}
          customSpeciality={customSpeciality}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Speciality;
